module.exports = __webpack_public_path__ + "static/media/9@3x.4e96f24f.png";